module.exports = __webpack_public_path__ + "static/media/imagine-pay-logo.43a5970c.png";